import { render, staticRenderFns } from "./SendPrescriptionsModal.vue?vue&type=template&id=6e9b90d8&"
import script from "./SendPrescriptionsModal.vue?vue&type=script&lang=js&"
export * from "./SendPrescriptionsModal.vue?vue&type=script&lang=js&"
import style0 from "./SendPrescriptionsModal.vue?vue&type=style&index=0&id=6e9b90d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports